import React from "react";
import PropTypes from "prop-types";
import { Input } from "discover.medical.react-component-library";
import { DIFilterContainer, DILabel, DIFilter } from "./styled";

const DrugInteractionFilter = ({ label, options, value, onChange }) => (
  <DIFilterContainer>
    <DILabel id="DrugInteractionFilter" label={label} labelResponsive>
      <DIFilter
        value={value}
        name="DrugInteractionFilter"
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((option) => (
          <Input.Select.Option key={option.type} value={option.type}>
            {option.label}
          </Input.Select.Option>
        ))}
      </DIFilter>
    </DILabel>
  </DIFilterContainer>
);

DrugInteractionFilter.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

DrugInteractionFilter.displayName = "DrugInteractionFilter";

export default DrugInteractionFilter;
